export default __webpack_public_path__ + "static/media/demographics-income-by-age-and-gender.png";